import React, { Component } from "react";
import _ from "lodash";
import { CannedType, ChatRegions, LoginResponse, Templates } from "../../models";
import { wglcsApiService } from "../../services/WglcsApiService";
import Spinner from "./../../components/spinner/spinner";
import EventEmitter, { Events } from "../../services/eventemitter";
import { ICannedMessage } from "../../models/index";
import { TreeTable, TreeTableExpandedKeysType } from "primereact/treetable";
import { Column } from "primereact/column";
import TreeNode from "primereact/treenode";
// import CannedNote from "./sendCannedNote/sendcannedNote";
import { utils } from '../../utils';
import { cacheService } from "../../services/cacheService";
import { InputText } from "primereact/inputtext";
import { connect } from "react-redux";
import { t } from "i18next";

interface CannedMessagesComponentState {
    checked: string[];
    expanded: string[];
    nodes: TreeNode[];
    loading: boolean;
    globalFilterKey: any;
    filteredItems: ICannedMessage[];
    isCannedNote: boolean;
    selectedRow: any;
    userData: LoginResponse;
    expandedKeys: TreeTableExpandedKeysType,
    CannedData: ICannedMessage[],
    pCanned: ICannedMessage[],
    websiteCanned: any | [],
    refreshCanned: boolean,
    websiteId: number,
    voiceNotification: any | [],
    selectedMessageId: number,
    selectedMessageText: string,
}

interface CannedMessagesComponentProps {
    websiteId: number;
    userId: number;
    languageId: number;
    type: CannedType;
    cannedHeight: number;
    websiteName: String;
    visitorId: String,
    allCannedMessages: any,
}



class CannedMessagesComponent extends Component<CannedMessagesComponentProps, CannedMessagesComponentState> {

    messageParentMap: Map<Number, Number> = new Map<Number, Number>();
    pressedKey: string = "";

    constructor(props) {
        super(props);
        var userData = JSON.parse(localStorage.getItem("USER_DATA")!) as LoginResponse;
        this.state = {
            checked: [],
            loading: false,
            expanded: [],
            nodes: [],
            globalFilterKey: null,
            filteredItems: [],
            isCannedNote: false,
            selectedRow: null,
            userData: userData,
            expandedKeys: {},
            CannedData: [],
            pCanned: [],
            websiteCanned: [],
            refreshCanned: false,
            websiteId: 0,
            voiceNotification: [],
            selectedMessageId: 0,
            selectedMessageText: "",
        };
        
        this.transformToTree = this.transformToTree.bind(this);
        this.fillTreeRecursive = this.fillTreeRecursive.bind(this);
        this.getHighlightText = this.getHighlightText.bind(this);

        EventEmitter.on(Events.FocusedOnWebsiteCanned, this.FocusedOnWebsiteCanned);
        EventEmitter.on(Events.changeRoom, this.changeRoom);
        EventEmitter.on(Events.GetCannedMsgs, this.refreshCanned)
        // EventEmitter.on(Events.voiceNotificationHeading, this.voiceNotificationHeading);
    }

    componentDidUpdate(prevProps: CannedMessagesComponentProps, prevState: CannedMessagesComponentState) {
        if (prevProps.websiteId != this.props.websiteId) {
            this.loadCannedMessages(this.props.websiteId)
        }
    }


    componentDidMount() {
        this.refreshCanned()
    }

    refreshCanned = () => {
        if (utils.isElectronBuild()) {
            window.myAPI?.ReturnPersistedCanned('ReturnPersistedCanned', (_e, data) => { 
                if (data != undefined) {
                    this.setState({ websiteCanned: JSON.parse(data) })
                    this.loadWebsiteCanned(JSON.parse(data), this.props.websiteId)
                }
            });

        }
        else {
            const state = this.props;
            this.setState({ websiteCanned: state.allCannedMessages?.PersonalCannedMessages?.allCannedMessages })
            this.loadWebsiteCanned(state.allCannedMessages?.PersonalCannedMessages?.allCannedMessages, this.props.websiteId)
        }
    }

    FocusedOnWebsiteCanned = () => {
        document.getElementById("PCannedSearch")?.focus();
    }
  

    changeRoom = (webId) => {
        this.setState({
            nodes: []
        });

        var webID = webId?.split(":")?.[0]
        var visiterID = webId?.split(":")?.[1]

        this.loadCannedMessages(webID);        
    }


    loadWebsiteCanned = (cannedMessage, websiteId) => {
        var result: ICannedMessage[] = [];
        var path = utils.getCurrentPathName()

        var canned = cannedMessage?.filter(x => x.websiteId == websiteId)
        result = canned;

        //we need to get canned messages by website id ,if website is not assigned to login user and user try to get any other operater chat from loggedin resource.
        if (canned?.length == 0 || canned == null || canned == undefined) {
            if ((utils.isSurveyExternalWindow() || utils.isChatLogScreenActive() || utils.isLoggedInResourcesScreenActive() || utils.isMonitoringPanelScreenActive()) && websiteId > 0) {
                this.getUnAssignWebsiteCanned(websiteId)
            }
        }
   

        this.messageParentMap = new Map(result?.map(a => [a.messageID, a.parentId]));
        this.setState({ CannedData: result });

        var filteredResult = _.filter(result, (item) => item.color?.toLowerCase() != "Black"?.toLowerCase());
        var nodes = this.transformToTree(filteredResult);
    
        this.setState({
            nodes: nodes,
            loading: false,
            globalFilterKey: "",
        } as CannedMessagesComponentState);

        setTimeout(() => {
            localStorage.setItem("surveyRouting","false")
        }, 5000);

    }


    getUnAssignWebsiteCanned = async (websiteId) => {
        var response = await wglcsApiService.getcannedmessagesbywebsite(websiteId, this.state.userData?.userLoginData?.languageId)
        if (response?.data?.status) {
            let customized = response?.data?.data?.map(x => ({ ...x, websiteId: x.webSiteId }))
            this.loadWebsiteCanned(customized, websiteId)
        }
    }

    loadCannedMessages = async (websiteId) => {
        if (this.state.websiteCanned?.length > 0) {
            this.loadWebsiteCanned(this.state.websiteCanned, websiteId)
        }
    }


    removeFirstWord = (str) => {
        const indexOfSpace = str.indexOf(' ');
        if (indexOfSpace === -1) {
            return '';
        }
        return str.substring(indexOfSpace + 1);
    }

   
    transformToTree(data: ICannedMessage[]): TreeNode[] {
        var nodes = _.chain(data)
            .filter((f: ICannedMessage) => f.parentId == -1)
            .map((item) => this.fromCannedToTreeNode(item))
            .valueOf();
        this.fillTreeRecursive(nodes, data);

        return nodes;
    }

    fromCannedToTreeNode(item: ICannedMessage): TreeNode {
        item.messageText = item.messageText ?? item["descr"];
        return { data: item, key: (item.messageID ?? item["id"]).toString() } as TreeNode;
    }

    fillTreeRecursive(nodes: TreeNode[], data: ICannedMessage[]) {
        for (let index = 0; index < nodes.length; index++) {
            const element = nodes[index];
            element.children = _.chain(data)
                .filter((f: ICannedMessage) => f.parentId == (element.data as ICannedMessage).messageID)
                .map((item) => this.fromCannedToTreeNode(item))
                .valueOf();

            this.fillTreeRecursive(element.children, data);
        }
    }

    getHighlightText(text: string, keyword: string) {
        const startIndex = text.indexOf(keyword);
        return startIndex !== 1 ? (
            <span>
                {text.substring(0, startIndex)}
                <span style={{ color: "blue" }}>{text.substring(startIndex, startIndex + keyword.length)}</span>
                {text.substring(startIndex + keyword.length)}
            </span>
        ) : (
            <span>{text}</span>
        );
    }

    onItemSelected(val: TreeNode) {
        this.setState({ selectedMessageId: (val.data as ICannedMessage).messageID as any ?? 0 })
    }

    getRowClassName = (node: TreeNode) => {
        var obj = {};
        var filtered = this.state.filteredItems;
        if (this.state.globalFilterKey != "" && filtered?.some(x => x.messageID.toString() === node.data?.messageID?.toString())) {
            obj[`search-nodes`] = true;
        } else {
            obj[`background-${(node.data as ICannedMessage).color?.toLowerCase() ?? "none"}`] = true;
        }

        if (this.state.selectedMessageId == (node.data as ICannedMessage)?.messageID) {
            obj[`active-row`] = true;
        }

        if (node?.children?.length == 0) {
            obj[`child-node`] = true;
        }

        return obj;
    };

    focusFirstNode = (nodes, globalFilterKey) => {

        for (let index = 0; index < nodes.length; index++) {
            const element = nodes[index];

            if (element?.data?.messageText?.toLowerCase().includes(globalFilterKey)) {
                const rowSelector = document.querySelector(`#node${element?.data?.messageID}`) || null
                if (rowSelector != null) {
                    rowSelector.scrollIntoView({ block: "start", inline: "start" });
                    return true;
                }
            }
            else {
                if (element?.children?.length > 0) {
                    let flag = this.focusFirstNode(element?.children, globalFilterKey)
                    if (flag) {
                        return true;
                    }
                }
            }
        }

        return false;
    }

    onGlobalFilterChange = (e: any) => {

        var globalFilterKey = (e.target.value.toLowerCase() as string);

        if (globalFilterKey == "") {
            this.setState({ expandedKeys: [] as any, globalFilterKey: globalFilterKey });
            return;
        }

        var filtered = this.state.CannedData?.filter(f => f.messageText.toLowerCase()?.includes(globalFilterKey));

        var filteredNodes: Number[] = [];
        filtered.map(element => {
            filteredNodes.push(element.messageID);
            var parentId = this.messageParentMap.get(element.messageID);
            while (parentId != undefined && parentId != null && parentId as any >= 0) {
                filteredNodes.push(parentId);
                parentId = this.messageParentMap.get(parentId);
            }
        })

        let expandKeys: TreeTableExpandedKeysType = {};
        for (let key of filteredNodes) {
            expandKeys[key.toString()] = true;
        }


        this.setState({ expandedKeys: expandKeys, globalFilterKey: globalFilterKey, filteredItems: filtered });
    }

    ExpandNode = (e) => {
        var key = e?.node?.key?.toString()
        const expandedKeys = this.state.expandedKeys;

        //remove key if exist  
        if (key in expandedKeys) {
            delete expandedKeys[key];
        }
        else {
            expandedKeys[key] = true;
        }
        this.setState({ expandedKeys: expandedKeys })
    }

    substractHeight = () => {
        if (utils.getCurrentTemplate() != Templates.Template1) {
            return 10;
        }
        else {
            return 65;
        }
    }

    substractHeightTemp1 = () => {
        if (utils.getCurrentTemplate() == Templates.Template1) {
            return 70;
        }
        else {
            return 0;
        }
    }

    reloadCanned = () => {
        this.setState({ nodes: [], loading: true })
        this.getUnAssignWebsiteCanned(this.props.websiteId)     
    }

    selectMessageText = (val: TreeNode) => {
        this.setState({ selectedMessageText: (val.data as ICannedMessage).messageText as any ?? "", selectedMessageId: (val.data as ICannedMessage).messageID as any ?? 0 })
    }


    messageTextTemplate = (row) => {
        return (<td className="canned-message-text" id={`node${row?.data?.messageID}`} title={row?.data?.messageText} onDoubleClick={(e) => this.selectCurrentRow(row)}>{row?.data?.messageText}</td>)
    }


    selectCurrentRow = (node: any) => {
        if (node.children?.length == 0) {
            this.onItemSelected(node);
        }
    }

    render() {
        let clicks = [] as any;
        let timeout;
        document.getElementById("treetbl")?.addEventListener("contextmenu", (event) => event.preventDefault());

        return (
            <div className="card shadow">
                {this.state.loading && this.props.websiteId > 0 ? <Spinner /> : <>
                    <div className="card-body p-c-msg">
                        <div className="personal-msgs">
                            <div className="tlClogo">
                                <div className="form-group has-search">

                                    <input
                                        size={50}
                                        onInput={(e) => this.onGlobalFilterChange(e)} placeholder={t("Search")}
                                        type="text"
                                        className="form-control form-controls"
                                        id="pCannedSearch"
                                        value={this.state.globalFilterKey}
                                    />

                                    <span className="font-icons">
                                        {this.state.globalFilterKey == "" ? <i className="fa fa-search"></i> : <span aria-hidden="true" onClick={() => this.setState({ globalFilterKey: "", expandedKeys: {} })}>&times;</span>}
                                    </span>
                                    <i title={t("wg-buttons.Refresh")} className="fa fa-refresh" onClick={() => this.reloadCanned()}></i>
                                </div>
                                <TreeTable
                                    value={this.state.nodes}
                                    selectionMode="single"
                                    onToggle={e => this.setState({ expandedKeys: e.value })}
                                    expandedKeys={this.state.expandedKeys}
                                    className=".p-treetable .p-treetable-header"
                                    rowClassName={this.getRowClassName}
                                    loading={this.state.loading}                                  

                                    // onSelect={(e) => {
                                    //     EventEmitter.emit(Events.getSelectedMessage, (e.node.data as ICannedMessage).messageText);

                                    //     if (e.node.children?.length == 0 || e.node.children == undefined) {
                                    //         this.selectMessageText(e.node)
                                    //     }
                                    //     else {
                                    //         this.ExpandNode(e)
                                    //     }
                                    // }}
                                >
                                    <Column colSpan={5} body={this.messageTextTemplate} field="messageText" expander></Column>
                                </TreeTable>
                            </div>
                        </div>
                        <div id="collapseOne" className="collapse">
                            <div className="card-body"></div>
                        </div>
                    </div>
                   
                </>}
            </div>
        );
        // }
    }
}

const mapStateToProps = (state) => {
    return {
        allCannedMessages: state, // Access the combined reducer state here
    };
};
export default connect(mapStateToProps)(CannedMessagesComponent);
